import Axios from 'axios'

const API = process.env.REACT_APP_API_URL

export const authorizationCall = async (_id, setIsFetching, isExpired, dispatch) => {
    try {
        //If the token is still valid
        if(!isExpired){
            const res = await Axios.get(API + `users/?userId=${_id}`)
            dispatch({
                type: 'LOGIN_SUCCESS',
                payload: res.data.user
            })
        }
        //If the token has expired
        else{
            dispatch({
                type: 'EXPIRED_SESSION',
                payload: null
            })
            localStorage.removeItem("token")
        }
        setIsFetching(false)
    } catch (error) {
        dispatch({
            type: 'LOGIN_FAILURE',
            payload: error
        })
        setIsFetching(false)
    }
}

export const loginCall = async (userCredentials, dispatch) => {
    dispatch({type: 'LOGIN_START' })
    try {
        const res = await Axios.post(API + 'auth/login' , userCredentials)
        localStorage.setItem("token", res.data.token)
        dispatch({
            type: 'LOGIN_SUCCESS',
            payload: res.data.user
        })
    } catch (error) {
        dispatch({
            type: 'LOGIN_FAILURE',
            payload: error
        })
    }
}